// import React from 'react';
// import { useTranslation } from 'react-i18next';


// const PricePage = ({ 
//   onButtonClick, 
//   onBack, 
//   onOpenRadiology, 
//   onOpenLab, 
//   onOpenCheckup, 
//   onOpenFunctional, 
//   onOpenCosmetology, 
//   onOpenDoctors,
// }) => {
//   const { t, i18n } = useTranslation();
  
//   const priceCategories = [
//     { 
//       icon: 'rentgen.png', 
//       name: 'Лучевая диагностика',
//       translationKey: 'radiology'
//     },
//     { 
//       icon: 'lab.png', 
//       name: 'Лабораторная диагностика',
//       translationKey: 'labDiagnostics'
//     },
//     { 
//       icon: 'checkup.png', 
//       name: 'Check-up',
//       translationKey: 'checkup'
//     },
//     { 
//       icon: 'functional.png', 
//       name: 'Функциональная диагностика',
//       translationKey: 'functionalDiagnostics'
//     },
//     // { 
//     //   icon: 'emergency.png', 
//     //   name: 'Неотложка',
//     //   translationKey: 'emergency'
//     // },
//     { 
//       icon: 'back.png', 
//       name: 'Назад',
//       translationKey: 'back'
//     }
//   ];

//   const handleCategoryClick = (categoryName, translationKey) => {
//     const englishName = translationKey ? t(`pricePage.categories.${translationKey}`) : categoryName;
    
//     if (categoryName === 'Назад' || englishName === 'Back') {
//       onBack();
//     } else if (categoryName === 'Лучевая диагностика' || translationKey === 'radiology') {
//       onOpenRadiology();
//     } else if (categoryName === 'Лабораторная диагностика' || translationKey === 'labDiagnostics') {
//       onOpenLab();
//     } else if (categoryName === 'Check-up' || translationKey === 'checkup') {
//       onOpenCheckup();
//     } else if (categoryName === 'Функциональная диагностика' || translationKey === 'functionalDiagnostics') {
//       onOpenFunctional();
//     } else if (categoryName === 'Косметология' || translationKey === 'cosmetology') {
//       onOpenCosmetology();
//     } else if (categoryName === 'Прием специалиста' || translationKey === 'doctorServices') {
//       onOpenDoctors();
//     }
//      else {
//       onButtonClick(englishName || categoryName);
//     }
//   };

//   return (
//     <>
//       <header className="header">
//         <div className="clinic-logo">
//           <div className="logo-icon">
//             <img src="/icons/price.png" alt={t('pricePage.title') || "Прайс-лист"} width="40" height="40" />
//           </div>
//           <h1>{t('pricePage.title') || "Прайс-лист"}</h1>
//         </div>
        
//         <div className="user-greeting">
//           <p>{t('pricePage.subtitle') || "Выберите категорию услуг"}</p>
//         </div>
//       </header>

//       <main className="main-content">
//         <div className="welcome-section">
//           <h2>{t('pricePage.welcome') || "Наши услуги и цены"}</h2>
//           <p className="subtitle">{t('pricePage.chooseCategory') || "Выберите интересующую категорию"}</p>
//         </div>

//         <div className="buttons-grid">
//           {priceCategories.map((category, index) => {
//             const translatedName = t(`pricePage.categories.${category.translationKey}`) || category.name;
//             const isBack = category.name === 'Назад' || translatedName === 'Back';
            
//             return (
//               <button 
//                 key={index}
//                 className={`service-btn ${isBack ? 'back-btn' : ''}`}
//                 onClick={() => handleCategoryClick(category.name, category.translationKey)}
//               >
//                 <span className="btn-icon">
//                   <img 
//                     src={`/icons/${category.icon}`} 
//                     alt={translatedName} 
//                     width="30" 
//                     height="30" 
//                   />
//                 </span>
//                 <span className="btn-text">{translatedName}</span>
//               </button>
//             );
//           })}
//         </div>
//       </main>

//       <footer className="footer">
//         <p>{t('pricePage.footer.main') || "Актуальные цены • Предварительная запись"}</p>
//         <p className="footer-info">
//           {t('pricePage.footer.info') || "Цены могут меняться в зависимости от сложности процедуры"}
//         </p>
//       </footer>
//     </>
//   );
// };

// export default PricePage;





import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// const API_URL = 'http://localhost:3001/api';
const API_URL = 'https://med-bot.dev-alb.ru/api';

const PricePage = ({ 
  onButtonClick, 
  onBack, 
  onOpenRadiology, 
  onOpenLab, 
  onOpenCheckup, 
  onOpenFunctional, 
  onOpenCosmetology, 
  onOpenDoctors,
}) => {
  const { t, i18n } = useTranslation();
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showSubcategories, setShowSubcategories] = useState(false);
  const [services, setServices] = useState([]);

  // Загрузка категорий из API
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${API_URL}/categories`);
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        console.error('Ошибка загрузки категорий:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchCategories();
  }, []);

  // Загрузка подкатегорий при выборе категории
  const fetchSubcategories = async (categoryId) => {
    try {
      const response = await fetch(`${API_URL}/subcategories?category_id=${categoryId}`);
      const data = await response.json();
      setSubcategories(data);
    } catch (error) {
      console.error('Ошибка загрузки подкатегорий:', error);
      setSubcategories([]);
    }
  };

  // Загрузка услуг по подкатегории
  const fetchServicesBySubcategory = async (subcategoryId) => {
    try {
      const response = await fetch(`${API_URL}/services?subcategory_id=${subcategoryId}`);
      const data = await response.json();
      setServices(data);
    } catch (error) {
      console.error('Ошибка загрузки услуг:', error);
      setServices([]);
    }
  };

  const handleCategoryClick = async (category) => {
    // Проверка на статические категории (обратная совместимость)
    if (category.name === 'Лучевая диагностика') {
      onOpenRadiology();
      return;
    }
    if (category.name === 'Лабораторная диагностика') {
      onOpenLab();
      return;
    }
    if (category.name === 'Check-up') {
      onOpenCheckup();
      return;
    }
    if (category.name === 'Функциональная диагностика') {
      onOpenFunctional();
      return;
    }
    
    // Для динамических категорий - показываем подкатегории
    setSelectedCategory(category);
    await fetchSubcategories(category.id);
    setShowSubcategories(true);
  };

  const handleSubcategoryClick = async (subcategory) => {
    await fetchServicesBySubcategory(subcategory.id);
    // Теперь показываем услуги вместо подкатегорий
    setSelectedCategory(prev => ({ ...prev, selectedSubcategory: subcategory }));
  };

  const handleBackToCategories = () => {
    setShowSubcategories(false);
    setSelectedCategory(null);
    setSubcategories([]);
    setServices([]);
  };

  const handleBackToSubcategories = () => {
    setServices([]);
    setSelectedCategory(prev => ({ ...prev, selectedSubcategory: null }));
  };

  // Статические кнопки (основные категории)
  const staticCategories = [
    { name: 'Лучевая диагностика', translationKey: 'radiology', icon: 'rentgen.png' },
    { name: 'Лабораторная диагностика', translationKey: 'labDiagnostics', icon: 'lab.png' },
    { name: 'Check-up', translationKey: 'checkup', icon: 'checkup.png' },
    { name: 'Функциональная диагностика', translationKey: 'functionalDiagnostics', icon: 'functional.png' }
  ];

  if (loading) {
    return (
      <>
        <header className="header">
          <div className="clinic-logo">
            <div className="logo-icon">
              <img src="/icons/price.png" alt={t('pricePage.title') || "Прайс-лист"} width="40" height="40" />
            </div>
            <h1>{t('pricePage.title') || "Прайс-лист"}</h1>
          </div>
        </header>
        <main className="main-content">
          <div className="loading-spinner" style={{ textAlign: 'center', padding: '40px', color: 'white' }}>
            Загрузка категорий...
          </div>
        </main>
      </>
    );
  }

  // Если показываем услуги
  if (services.length > 0 && selectedCategory?.selectedSubcategory) {
    return (
      <>
        <header className="header">
          <div className="clinic-logo">
            <div className="logo-icon">
              <img src="/icons/price.png" alt={t('pricePage.title') || "Прайс-лист"} width="40" height="40" />
            </div>
            <h1>{selectedCategory.selectedSubcategory.name}</h1>
          </div>
        </header>

        <main className="main-content">
          <div className="welcome-section">
            <h2>{selectedCategory.selectedSubcategory.name}</h2>
            <p className="subtitle">Услуги и цены</p>
          </div>

          <div className="services-list-section">
            <div className="services-scroll-container">
              {services.map((service) => (
                <div key={service.id} className="service-item">
                  <div className="service-info">
                    <span className="service-name">{service.name}</span>
                    <span className="service-price">{service.price} ₽</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="buttons-grid">
            <button 
              className="service-btn back-btn"
              onClick={handleBackToSubcategories}
            >
              <span className="btn-icon">←</span>
              <span className="btn-text">Назад к подкатегориям</span>
            </button>
          </div>
        </main>

        <footer className="footer">
          <p>Актуальные цены • Предварительная запись</p>
          <p className="footer-info">Цены могут меняться в зависимости от сложности процедуры</p>
        </footer>
      </>
    );
  }

  // Если показываем подкатегории
  if (showSubcategories && selectedCategory) {
    return (
      <>
        <header className="header">
          <div className="clinic-logo">
            <div className="logo-icon">
              <img src="/icons/price.png" alt={t('pricePage.title') || "Прайс-лист"} width="40" height="40" />
            </div>
            <h1>{selectedCategory.name}</h1>
          </div>
        </header>

        <main className="main-content">
          <div className="welcome-section">
            <h2>{selectedCategory.name}</h2>
            <p className="subtitle">Выберите подкатегорию</p>
          </div>

          <div className="buttons-grid">
            {subcategories.map((subcategory) => (
              <button 
                key={subcategory.id}
                className="service-btn"
                onClick={() => handleSubcategoryClick(subcategory)}
              >
                <span className="btn-icon">📂</span>
                <span className="btn-text">{subcategory.name}</span>
              </button>
            ))}

            {subcategories.length === 0 && (
              <div className="no-subcategories" style={{ textAlign: 'center', padding: '40px', color: 'rgba(255,255,255,0.7)' }}>
                <p>В этой категории пока нет подкатегорий</p>
              </div>
            )}

            <button 
              className="service-btn back-btn"
              onClick={handleBackToCategories}
            >
              <span className="btn-icon">←</span>
              <span className="btn-text">Назад к категориям</span>
            </button>
          </div>
        </main>

        <footer className="footer">
          <p>Актуальные цены • Предварительная запись</p>
          <p className="footer-info">Цены могут меняться в зависимости от сложности процедуры</p>
        </footer>
      </>
    );
  }

  return (
    <>
      <header className="header">
        <div className="clinic-logo">
          <div className="logo-icon">
            <img src="/icons/price.png" alt={t('pricePage.title') || "Прайс-лист"} width="40" height="40" />
          </div>
          <h1>{t('pricePage.title') || "Прайс-лист"}</h1>
        </div>
        
        <div className="user-greeting">
          <p>{t('pricePage.subtitle') || "Выберите категорию услуг"}</p>
        </div>
      </header>

      <main className="main-content">
        <div className="welcome-section">
          <h2>{t('pricePage.welcome') || "Наши услуги и цены"}</h2>
          <p className="subtitle">{t('pricePage.chooseCategory') || "Выберите интересующую категорию"}</p>
        </div>

        <div className="buttons-grid">
          {/* Статические категории */}
          {staticCategories.map((category, index) => {
            const translatedName = t(`pricePage.categories.${category.translationKey}`) || category.name;
            
            return (
              <button 
                key={index}
                className="service-btn"
                onClick={() => {
                  if (category.name === 'Лучевая диагностика') {
                    onOpenRadiology();
                  } else if (category.name === 'Лабораторная диагностика') {
                    onOpenLab();
                  } else if (category.name === 'Check-up') {
                    onOpenCheckup();
                  } else if (category.name === 'Функциональная диагностика') {
                    onOpenFunctional();
                  }
                }}
              >
                <span className="btn-icon">
                  <img 
                    src={`/icons/${category.icon}`} 
                    alt={translatedName} 
                    width="30" 
                    height="30" 
                  />
                </span>
                <span className="btn-text">{translatedName}</span>
              </button>
            );
          })}

          {/* Динамические категории из API (исключая статические, чтобы не дублировать) */}
          {categories
            .filter(cat => !['Лучевая диагностика', 'Лабораторная диагностика', 'Check-up', 'Функциональная диагностика'].includes(cat.name))
            .map((category) => (
              <button 
                key={category.id}
                className="service-btn"
                onClick={() => handleCategoryClick(category)}
              >
                <span className="btn-icon">📁</span>
                <span className="btn-text">{category.name}</span>
              </button>
            ))}

          {/* Кнопка "Назад" в самом низу */}
          <button 
            className="service-btn back-btn"
            onClick={onBack}
          >
            <span className="btn-icon">←</span>
            <span className="btn-text">{t('pricePage.categories.back') || "Назад"}</span>
          </button>
        </div>
      </main>

      <footer className="footer">
        <p>{t('pricePage.footer.main') || "Актуальные цены • Предварительная запись"}</p>
        <p className="footer-info">
          {t('pricePage.footer.info') || "Цены могут меняться в зависимости от сложности процедуры"}
        </p>
      </footer>
    </>
  );
};

export default PricePage;